// Modules
import React from 'react'

// Routes
import Routes from './routes/Main'

// Components
import Page from 'components/layout/page/Page'

// Hooks
// import useLanguage from 'hooks/system/useLanguage'

// Styles
import './Register.scss'

// Page: Register
function Register () {
	// Data
	// const { translate } = useLanguage('pages.register')

	// Render
	return (
		<Page
			isPublic
			name="register">
			<Routes />
		</Page>
	)
}

// Export
export default Register
